export const staticText = {
  pagination: {
    container: "Pagination",
    page: "Page",
    currentPage: "Current Page",
    gotoPage: "Go to Page ",
    gotoPreviousPage: "Go to Previous Page",
    gotoNextPage: "Go to Next Page",
    footerText: "Showing {startResult}-{endResult} of {totalResults} result{s}",
    morePagesAriaLabel: "More pages",
  },
  input: {
    tooltipShow: "Show",
    tooltipHide: "Hide",
  },
  backButton: {
    label: "Back",
  },
  statusChip: {
    active: "Active",
    pending: "Pending",
    inactive: "Inactive",
    inPerpetuity: "In Perpetuity",
  },
  copyable: {
    tooltip: "Click to copy",
    copyError: "Failed to copy to clipboard!",
    confirmation: "Copied to clipboard",
  },
  selection: {
    dismissAriaLabel: "Dismiss",
    selectAriaLabel: "Select",
    selectAllAriaLabel: "Select all",
  },
  countBadge: {
    cutoffText: "9+",
  },
};
